/* eslint-disable prefer-template */
/* eslint-disable prefer-object-spread */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Hub } from 'aws-amplify';
import uuid from "react-uuid";
import { Button, Grid, Header, Message } from 'semantic-ui-react';

// material
import { styled } from '@mui/material/styles';
import { Container, Link } from '@mui/material';
import MyTextInput from '../components/common/form/MyTextInput';
import MySelectInput from '../components/common/form/MySelectInput';
import { userOptions } from '../services/complaint.data';
import { signUpStart } from '../redux/auth/auth.actions';

// components
import Page from '../components/Page';
import ClientMenuLeft from './common/ClientMenuLeft';
import { listComplaintUsers } from '../graphql/queries';
import { createComplaintUser } from '../graphql/mutations';
import DisplayCognitoError from "../components/common/DisplayCognitoError";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function AdminRegisterPage() {
  const dispatch = useDispatch();

  const [addUserComplaint] = useMutation(createComplaintUser, {
    refetchQueries: [{ query: listComplaintUsers }]
  });
  const [errorMessage, setErrorMessage] = useState(null);
  const createDynamoUser = async (userDynamoDB) => {
    try {
      await addUserComplaint({
        variables: { input: userDynamoDB }
      });
    } catch (err) {
      setErrorMessage(err);
    }
  };
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const { currentErrorRegister } = useSelector((state) => state.authReducer);

  const navigate = useNavigate();

  const initialValues = {
    firstname: '',
    lastname: '',
    username: '',
    password: '',
    userType: ''
  };

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().required('Votre prenom est un champ obligatoire'),
    lastname: Yup.string().required('Votre nom est un champ obligatoire'),
    userType: Yup.string().required("Votre type d'utilisteur est un champ obligatoire"),
    username: Yup.string().required('Adresse e-mail est un champ obligatoire').email('Doit être sous la forme xxx@xxx.xx')
    .matches(
      /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(comtel-group)\.com$/,
      "Adresse e-mail doit être celle de @comtel-group.com"
    ),
    password: Yup.string().required('Mot de passe est un champ obligatoire')
  });

  const handleSubmit = (values) => {
    try {
      const payload = {
        id: values.username,
        given_name: values.firstname,
        name: values.firstname + ' ' + values.lastname,
        family_name: values.lastname,
        username: values.username,
        password: values.password,
        email: values.username,
        phone_number: values.phone,
        website: values.company,
        picture: '/assets/user.png',
        profile: values.userType,
        gender: ''
      };

      const userDynamoDB = {
        cognitoId:  uuid(),
        name: values.firstname + ' ' + values.lastname,
        email: values.username,
        userType: 'ADMIN'
      };

      window.localStorage.setItem("usernameConfirmAdmin", values.username);

      dispatch(signUpStart(payload));

      Hub.listen('auth', (data) => {
        const { payload } = data;
        if (payload.event === 'signUp') {
          try {
            // console.log(JSON.stringify(userDynamoDB, null, 2));
            createDynamoUser(userDynamoDB);
            navigate('/admin-register-confirm', { replace: true });
          } catch (error) {
            console.log(errorMessage);
            console.log(JSON.stringify(error, null, 2));
          }
        }
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <RootStyle title="Register | Gestion des plaintes">
    <ClientMenuLeft />
      <Container>
        <ContentStyle>
          {' '}
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h2" color="blue" textAlign="center">
                Inscription des employés
              </Header>

              <DisplayCognitoError errorMessage={currentErrorRegister} />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, isValid, dirty }) => (
                  <Form className="ui form">
                    <MyTextInput name="firstname" placeholder="Votre prenom" />
                    <MyTextInput name="lastname" placeholder="Votre nom" />
                    <MySelectInput
                      name="userType"
                      placeholder="Type d'utilisateur"
                      options={userOptions}
                    />
                    <MyTextInput name="username" placeholder="Adresse e-mail" />
                    <div className="ui icon input">
                      <MyTextInput
                         name="password" placeholder="Votre mot de passe" type={passwordShown ? "text" : "password"} size="60" />
                      <i aria-hidden="true" onClick={togglePassword} className="eye link icon"></i>
                    </div>
                    <Button
                      type="submit"
                      fluid
                      size="large"
                      color="blue"
                      content="S'inscrire"
                    />
                  </Form>
                )}
              </Formik>
              <Message>
                <Link underline="none" variant="subtitle2" component={RouterLink} to="/admin">
                  S'identifier
                </Link>
              </Message>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
